var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b(
      {
        class: [
          _vm.$style.block,
          _vm.secondary ? _vm.$style.secondary : null,
          _vm.white ? _vm.$style.white : null,
          _vm.transparent ? _vm.$style.transparent : null
        ]
      },
      "div",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }